import TimbradoMasivoInfoStore from './TimbradoMasivoInfoStore';
import TimbradoMasivoListStore from './TimbradoMasivoListStore';
import TimbradoMasivoUploadStore from './TimbradoMasivoUploadStore';
import TimbradoMasivoTicketListStore from './TimbradoMasivoTicketListStore';

const TimbradoMasivoStore = {
  info: TimbradoMasivoInfoStore,
  upload: TimbradoMasivoUploadStore,
  archivos: TimbradoMasivoListStore,
  tickets: TimbradoMasivoTicketListStore,
};

export default TimbradoMasivoStore;
